// @flow
import * as React from 'react';
import { Switch as RNSwitch } from 'react-native';
import * as Yup from 'yup';
import { get } from 'lodash';
import {
    defineMessages,
} from 'react-intl';
import FieldWrapperRNE from './FieldWrapperRNE';


type Props = {
    field: {
        value: boolean,
        name: string,
    },
    form: {
        errors: Object,
        touched: Object,
        isSubmitting: boolean,
        handleChange: (name: string) => (value: boolean) => void,
        handleBlur: (name: string) => () => void,
    },
    required: boolean,
    label: string,
    help_text: string,
    disabled?: boolean,
}


const Switch = (props: Props): React.Node => {
    const {
        disabled,
        field: { name, value },
        form: {
            errors, touched, isSubmitting,
            handleChange, handleBlur,
        },
        label,
        help_text: help,
        required,
    } = props;

    const errs = get(errors, name);

    const onChange = React.useCallback((_value: boolean) => {
        handleChange(name)(_value);
        handleBlur(name)();
    }, [name, handleChange, handleBlur]);

    return (
        <FieldWrapperRNE
            required={required}
            helpText={help}
            label={label}
            touched={touched[name]}
            errors={errs}
        >
            <RNSwitch
                onValueChange={onChange}
                value={value !== null ? value : false}
                disabled={disabled || isSubmitting}
            />
        </FieldWrapperRNE>
    );
};


const messages = defineMessages({
    required: {
        id: 'switch-required',
        defaultMessage: 'This field is required.',
    },
});

Switch.getValidationSchema = (field: { validation: Object }) => {
    if (field.validation.required) {
        return Yup.bool().required(messages.required).nullable();
    }

    return Yup.bool().nullable();
};

Switch.defaultProps = {
    disabled: false,
};

export default Switch;
